import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import CategoryExplorer from './customize/CategoryExplorer';
import ServicesCardsSlider from './customize/ServicesCardsSlider';
import BestFriend from './shared/BestFriend';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { customerJourneyCategories, customerJourneyServices } from './../../actions';

import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';

const customizeBannerImage = require('./../../images/customize_banner.jpg');

import './customize.scss';

class Customize extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.actions.customerJourneyCategories(this.props.token, this.props.currentLanguage, this.props.context, (categories) => {
      if(categories.length > 0) {
        const selectedCategory = find(categories, {id: this.props.cat_id}) || categories[0];
        this.props.actions.customerJourneyServices(selectedCategory.id, this.props.token, this.props.currentLanguage, this.props.context);
      }
    });
  }

  render() {

    const emptyCategories = (
      <div>
        <br/>
        <h2 className="text-center">{this.props.translate('customize.empty_categories')}</h2>
        <br/>
      </div>
    );
    
    const withCategories = (
      <div>
        <CategoryExplorer catId={this.props.cat_id || (this.props.categories.apiData[0] || {}).id}/>
        <br/>
        
        <ServicesCardsSlider/>
        <br/>
      </div>
    );

    const bannerImageStyle = {backgroundImage: `url(${customizeBannerImage})`};

    return (
      <Grid className="customize-component">

      <Row className="customize-banner">
        <div className="customize-banner__image-holder" style={bannerImageStyle}>

          <div className="customize-banner__overlay"></div>

          <Col sm={6}>
            <div className="customize-banner__text-holder">
              <div>
                <h4>{this.props.translate('customize.header')}</h4>

                <div className="customize-banner__text">
                  <h3>
                    {this.props.translate('customize.title')}
                  </h3>
                  <br/>
                  <h5>{this.props.translate('customize.text')}<strong>{this.props.hotel.apiData.name}</strong></h5>
                </div>
              </div>
            </div>
          </Col>

        </div>
      </Row>

      { isEmpty(this.props.categories.apiData) && !this.props.categories.loading ? emptyCategories : withCategories }

      <BestFriend/>

    </Grid>
    );
  }
}

Customize.displayName = 'PagesCustomize';
Customize.propTypes = {};
Customize.defaultProps = {};

const mapStateToProps = (state, ownProps) => {

  return { 
      translate: getTranslate(state.locale),
      currentLanguage: getActiveLanguage(state.locale).code,
      token: state.commons.token,
      context: state.commons.context,
      cat_id: ownProps.match.params.cat_id,
      hotel: state.hotel,
      categories: state.categories
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      customerJourneyCategories: bindActionCreators(customerJourneyCategories, dispatch),
      customerJourneyServices: bindActionCreators(customerJourneyServices, dispatch)
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Customize);



// WEBPACK FOOTER //
// ./components/pages/Customize.js